import { IconProps } from '../icon';

export function LogoGreenkubIcon(props: IconProps) {
  return (
    <svg
      height="161.5"
      width="680"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m644.809 60.604c0-2.527-2.054-6.792-8.689-6.792h-15.953v12.715h15.953c6.556-.001 8.689-2.766 8.689-5.923zm-8.69 15.084h-15.953v14.215h15.953c4.266 0 10.348-1.421 10.348-6.634 0-4.975-6.082-7.581-10.348-7.581zm-313.696-27.405h-20.06v26.378h19.586c9.636 0 13.899-5.449 13.978-13.189.08-6.476-4.342-13.189-13.504-13.189z"
        fill="none"
      />
      <path
        d="m116.164 118.638-54.554-20.991zm100.809-12.752c0-13.226-16.412-24.94-41.647-32.161l.027 23.917.004 3.196-2.984 1.149-54.539 20.991-1.67.644-1.671-.644-54.553-20.989-2.981-1.148v-27.129c-25.26 7.22-41.691 18.94-41.691 32.174 0 21.94 45.153 39.729 100.852 39.729 55.7-.001 100.853-17.789 100.853-39.729z"
        fill="#41B883"
      />
      <path
        d="m114.26 57.792c0-.333.102-.641.256-.918.133-.239.308-.448.531-.611a1.87 1.87 0 0 1 .431-.247l12.887-4.965 25.925-9.99-38.042-14.701-41.665 16.01v47.58l39.677 15.265z"
        fill="#41B883"
      />
      <path
        d="m118.065 59.098v14.119l39.662 15.266-.051-44.649z"
        fill="#41B883"
      />
      <path
        d="m116.164 118.638 54.539-20.991-.072-62.973-54.358-21.005-54.663 21.005v62.974zm-44.166-79.351 43.569-16.743c.44-.17.928-.169 1.368.002l43.304 16.733h.002l.02.008c.019.007.032.021.051.029.117.049.232.104.339.177.021.015.037.035.058.051.049.037.09.078.135.119a1.893 1.893 0 0 1 .341.403c.063.103.114.21.157.323.02.051.043.099.058.151.048.168.079.341.079.52l.057 50.011a1.902 1.902 0 0 1 -1.894 2.085h-.009c-.23 0-.462-.041-.683-.127l-40.884-15.736v30.511a1.902 1.902 0 0 1 -1.894 2.085h-.008c-.231 0-.462-.042-.684-.128l-43.481-16.73a1.901 1.901 0 0 1 -1.22-1.775v-50.194a1.899 1.899 0 0 1 1.219-1.775z"
        fill="#41B883"
      />
      <path
        d="m56.959 100.841 2.981 1.148 54.553 20.989 1.671.644 1.67-.644 54.539-20.991 2.984-1.149-.004-3.196-.027-23.917-.044-39.056-.004-3.185-2.971-1.148-54.358-21.005-1.672-.646-1.672.643-54.664 21.005-2.982 1.147zm4.651-66.167 54.663-21.005 54.358 21.005.072 62.973-54.539 20.991-54.554-20.991z"
        fill="#fff"
      />
      <path
        d="m160.708 39.544c.049.036.091.079.135.119-.044-.04-.086-.082-.135-.119zm-.447-.256-.02-.008c.024.009.046.026.07.037-.018-.007-.032-.022-.05-.029zm1.08 1.102c.02.051.043.099.058.151-.015-.053-.039-.101-.058-.151zm-46.294 15.872a1.87 1.87 0 0 1 .431-.247l12.887-4.966-12.887 4.965a1.933 1.933 0 0 0 -.431.248z"
        fill="#fff"
      />
      <path
        d="m70.778 91.256c0 .787.485 1.493 1.22 1.775l43.481 16.73c.222.086.453.128.684.128h.008a1.903 1.903 0 0 0 1.894-2.085v-30.51l-2.586-.995a1.9 1.9 0 0 1 -1.219-1.775v30.691l-39.677-15.265v-47.58l41.665-16.012 38.042 14.702 4.601-1.773a1.911 1.911 0 0 1 1.349-.007l-43.304-16.733a1.893 1.893 0 0 0 -1.368-.002l-43.57 16.742a1.901 1.901 0 0 0 -1.22 1.775z"
        fill="#fff"
      />
      <path
        d="m158.891 39.287-4.601 1.773-25.925 9.99-12.887 4.966c-.158.061-.298.15-.431.247a1.875 1.875 0 0 0 -.531.611 1.89 1.89 0 0 0 -.256.918v16.731a1.9 1.9 0 0 0 1.219 1.775l2.586.995 40.884 15.736c.221.086.453.127.683.127h.009a1.903 1.903 0 0 0 1.894-2.085l-.057-50.011c0-.179-.031-.352-.079-.52-.015-.052-.039-.101-.058-.151a1.853 1.853 0 0 0 -.261-.472 1.893 1.893 0 0 0 -.237-.254c-.044-.041-.086-.083-.135-.119-.021-.016-.036-.036-.058-.051a1.99 1.99 0 0 0 -.339-.177c-.024-.01-.046-.027-.07-.037h-.002a1.903 1.903 0 0 0 -1.348.008zm-1.164 49.196-39.662-15.267v-14.118l39.611-15.264z"
        fill="#fff"
      />
      <path
        d="m266.428 47.415c6.239 0 12.952 2.369 17.769 7.108l2.449-2.686a28.778 28.778 0 0 0 -20.218-8.291c-16.822 0-28.589 11.292-28.51 28.588 0 15.085 9.714 28.194 28.51 28.194 8.213 0 15.084-3.159 20.849-8.925v-20.691h-23.297v3.713h19.269v15.479c-4.738 4.344-10.898 6.397-16.821 6.397-16.111 0-24.403-11.215-24.403-24.246-.079-12.794 8.213-24.64 24.403-24.64zm74.161 14.136c-.08-8.609-6.162-17.217-18.166-17.217h-24.324v55.284h4.265v-20.93h15.084l19.111 20.93h5.609l-19.508-21.167c12.083 0 18.006-7.897 17.929-16.9zm-18.64 13.11h-19.586v-26.378h20.06c9.162 0 13.584 6.713 13.504 13.189-.078 7.74-4.342 13.189-13.978 13.189zm65.471-26.298v-4.029h-38.146v55.284h39.093v-4.106h-34.907v-21.799h32.381v-3.869h-32.381v-21.481zm48.492 0v-4.029h-38.145v55.284h39.093v-4.106h-34.907v-21.799h32.38v-3.869h-32.38v-21.481zm53.627 51.255h1.658v-55.284h-4.187v45.728l-37.196-45.728h-1.817v55.284h4.264v-45.648zm12.794-55.283v55.283h10.425v-24.483l23.139 24.483h12.874v-.633l-26.615-27.878 24.563-26.456v-.316h-12.953l-21.008 23.376v-23.376zm49.203.079v31.669c0 16.663 11.293 24.719 24.561 24.719 13.9 0 23.931-8.371 23.931-24.719v-31.669h-10.348v31.669c0 9.478-4.896 15.242-13.504 15.242-8.607 0-14.295-5.292-14.295-15.242v-31.669zm96.431 26.614c5.134-2.291 7.187-6.397 7.187-10.662 0-11.135-8.134-16.032-19.034-16.032h-26.22v55.284h26.22c11.452 0 20.693-3.949 20.693-16.27-.001-3.475-2.371-10.345-8.846-12.32zm-27.801-17.216h15.953c6.636 0 8.689 4.265 8.689 6.792 0 3.158-2.133 5.923-8.689 5.923h-15.953zm15.953 36.091h-15.953v-14.215h15.953c4.266 0 10.348 2.605 10.348 7.581 0 5.213-6.082 6.634-10.348 6.634z"
        fill="#41B883"
      />
      <path d="m238 114.393h418.812v20.349h-418.812z" fill="none" />
      <g fill="#8bbf46">
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(238 133.086)"
        >
          E
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(255.342 133.086)"
        >
          T
        </text>
        <text transform="translate(271.224 133.086)" />
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(282.373 133.086)"
        >
          L
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(296.833 133.086)"
        >
          E
        </text>
        <text transform="translate(314.175 133.086)" />
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(325.324 133.086)"
        >
          J
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(338.324 133.086)"
        >
          A
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(355.666 133.086)"
        >
          R
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(374.442 133.086)"
        >
          D
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(393.219 133.086)"
        >
          I
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(400.442 133.086)"
        >
          N
        </text>
        <text transform="translate(419.219 133.086)" />
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(430.37 133.086)"
        >
          D
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(449.146 133.086)"
        >
          E
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(466.487 133.086)"
        >
          V
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(483.83 133.086)"
        >
          I
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(491.053 133.086)"
        >
          E
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(508.394 133.086)"
        >
          N
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(527.17 133.086)"
        >
          T
        </text>
        <text transform="translate(543.053 133.086)" />
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(554.202 133.086)"
        >
          M
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(575.86 133.086)"
        >
          A
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(593.202 133.086)"
        >
          I
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(600.426 133.086)"
        >
          S
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(617.768 133.086)"
        >
          O
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(637.991 133.086)"
        >
          N
        </text>
      </g>
    </svg>
  );
}

export default LogoGreenkubIcon;
